import React from 'react';
import { Box, Skeleton } from '@mui/material';

export const AddressesLoadingLayout = () => {
    return (
        <>
            <Box>
                <Box sx={{ width: '70%', padding: '10px 0' }}>
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                </Box>
                <Box sx={{ display: 'flex', gap: '10px' }}>
                    <Box sx={{ width: '50%' }}>
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    </Box>
                    <Box sx={{ width: '50%' }}>
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    </Box>
                </Box>
            </Box>
        </>
    );
};
